import React from "react";
import InputRadio from "../InputRadio/InputRadio";

import PrewButton from "../PrewButton/PrewButton";
import NextButton from "../NextButton/NextButton";

const PROFESSIONS_CHOICES = [
  { value: 1, title: "Экскурсовод" },
  { value: 2, title: "Администратор гостиницы" },
];

function Step2(props) {
  const { profession, setProfession, setStep } = props;

  return (
    <form action=".">
      <div className="mm-form__inner">
        <InputRadio
          title="Профессия"
          choices={PROFESSIONS_CHOICES}
          name="professions"
          onChange={setProfession}
          value={profession}
        />
      </div>

      <div className="buttons-wrapper">
        <PrewButton
          onClick={() => {
            setStep(1);
            setProfession(null);
          }}
        />
        <NextButton
          disabled={profession ? false : true}
          onClick={() => setStep(3)}
        />
      </div>
    </form>
  );
}

export default Step2;
